import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { PrinterType, PrinterTypes, ToPrintTypeDefaultLabel, QuoteFilterOptions } from '~/lib/quotes';
import Filter from './quote-filter-option';
import { sanitiseKey } from '~/lib/utils/translation';

export default function QuoteFilterPrinter({
  filter,
  onChange,
  title,
  dataTestId
}: {
  title?: string;
  dataTestId?: string;
  filter: QuoteFilterOptions;
  onChange: (filter: QuoteFilterOptions) => void;
}) {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);

  return (
    <Filter
      dataTestId={dataTestId}
      options={PrinterTypes.map((s) => ({
        type: s,
        label: t(sanitiseKey(`FILTER_PRINTER_TYPE_OPTION_${s}`), { defaultValue: ToPrintTypeDefaultLabel(s) })
      }))}
      selected={filter.printerTypes}
      title={title}
      onChange={(v) =>
        onChange({
          ...filter,
          printerTypes: filter.printerTypes?.includes(v as PrinterType)
            ? filter.printerTypes.filter((x) => x !== v)
            : (filter.printerTypes ?? []).concat([v as PrinterType])
        })
      }
    />
  );
}
